/*
 * @Description: 
 * @Author: xgx
 * @Date: 2022-10-08 15:33:58
 * @LastEditors: xgx
 * @LastEditTime: 2023-03-03 16:29:58
 */
import req from "@/utils/request";

//  添加账号
export const login = (params) => req.post("/manager-service/m/management/login", params);
export const loginAuto = (params) => req.post("/manager-service/m/management/ssoLogin", params);

// 获取秘钥
export const getAuth = (params) => req.get("/manager-service/get-api-auth", params);
// 图片上传
export const uploadImage = (params) => req.file("/site-service/m/cover/uploadImage", params);
export const uploadVideoFile = (params) => req.file("/site-service/m/cover/uploadVideo", params);

export const list = (params) => req.post("/site-service/m/site/getSiteByUserId", params);
export const loginOut = (params) => req.post("/manager-service/m/management/loginOut", params);
export const selectRoleMenu = (params) => req.post("/manager-service/m/roleMenu/selectRoleMenu", params);
export const updatePassword = (params) => req.post("/manager-service/m/management/updatePassword", params);

